import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Format from "bs-platform/lib/es6/format.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Hashtbl from "bs-platform/lib/es6/hashtbl.js";
import * as Std$Bolt0 from "bolt0/./std.bs.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
var compare = $$String.compare;
var $$String$1 = {
  make: $$String.make,
  init: $$String.init,
  copy: $$String.copy,
  sub: $$String.sub,
  fill: $$String.fill,
  blit: $$String.blit,
  concat: $$String.concat,
  iter: $$String.iter,
  iteri: $$String.iteri,
  map: $$String.map,
  mapi: $$String.mapi,
  trim: $$String.trim,
  escaped: $$String.escaped,
  index: $$String.index,
  index_opt: $$String.index_opt,
  rindex: $$String.rindex,
  rindex_opt: $$String.rindex_opt,
  index_from: $$String.index_from,
  index_from_opt: $$String.index_from_opt,
  rindex_from: $$String.rindex_from,
  rindex_from_opt: $$String.rindex_from_opt,
  contains: $$String.contains,
  contains_from: $$String.contains_from,
  rcontains_from: $$String.rcontains_from,
  uppercase: $$String.uppercase,
  lowercase: $$String.lowercase,
  capitalize: $$String.capitalize,
  uncapitalize: $$String.uncapitalize,
  uppercase_ascii: $$String.uppercase_ascii,
  lowercase_ascii: $$String.lowercase_ascii,
  capitalize_ascii: $$String.capitalize_ascii,
  uncapitalize_ascii: $$String.uncapitalize_ascii,
  equal: $$String.equal,
  split_on_char: $$String.split_on_char,
  compare: compare,
  hash: Hashtbl.hash
};

function Make(List_ext, Bigdata) {
  var compare$1 = function compare$1(t, t$prime) {
    return Curry._3(List_ext.compare, compare, Bolt0_list$Bolt0.sort(compare, t), Bolt0_list$Bolt0.sort(compare, t$prime));
  };

  var hash = function hash(t) {
    return Hashtbl.hash($$String.concat("", Bolt0_list$Bolt0.sort(compare, t)));
  };

  var singleton = function singleton(s) {
    return (
      /* :: */
      [s,
      /* [] */
      0]
    );
  };

  var Labels = {
    compare: compare$1,
    hash: hash,
    singleton: singleton
  };

  var to_alist = function to_alist(t) {
    return t;
  };

  var to_array = $$Array.of_list;

  var of_alist = function of_alist(labeled_data) {
    var match = Curry._2(List_ext.find_a_dup, function (param, param$1) {
      return compare$1(param[0], param$1[0]);
    }, labeled_data);

    if (match !== undefined) {
      return (
        /* `Duplicate_key */
        [-1048878709, match[0]]
      );
    } else {
      return (
        /* `Ok */
        [17724, labeled_data]
      );
    }
  };

  var of_alist_exn = function of_alist_exn(labeled_data) {
    var param = of_alist(labeled_data);

    if (param[0] >= 17724) {
      return param[1];
    } else {
      return Curry._2(Std$Bolt0.failwithf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["Dataframe.of_alist_exn: duplicate key \"",
      /* String */
      Block.__(2, [
      /* No_padding */
      0,
      /* Char_literal */
      Block.__(12, [
      /* "\"" */
      34,
      /* End_of_format */
      0])])]), "Dataframe.of_alist_exn: duplicate key \"%s\""]), $$String.concat(",", param[1]),
      /* () */
      0);
    }
  };

  var singleton$1 = function singleton$1(labels, data) {
    return of_alist_exn(
    /* :: */
    [
    /* tuple */
    [labels, data],
    /* [] */
    0]);
  };

  var num_frames = List.length;

  var to_term = function to_term(t) {
    return (
      /* `Frames */
      [-518380602, t]
    );
  };

  var of_term = function of_term(param) {
    return param[1];
  };

  var to_string_alist = function to_string_alist(t) {
    return List.concat(Bolt0_list$Bolt0.map(function (param) {
      var bigdata = param[1];
      return Bolt0_list$Bolt0.map(function (label) {
        return (
          /* tuple */
          [label, bigdata]
        );
      }, param[0]);
    }, t));
  };

  var formats = function formats(t) {
    return Bolt0_list$Bolt0.map(function (param) {
      return (
        /* tuple */
        [param[0], Curry._1(Bigdata.cell_format, param[1])]
      );
    }, to_string_alist(t));
  };

  var Frames = {
    Labels: Labels,
    to_alist: to_alist,
    to_array: to_array,
    of_alist: of_alist,
    of_alist_exn: of_alist_exn,
    singleton: singleton$1,
    num_frames: num_frames,
    to_term: to_term,
    of_term: of_term,
    to_string_alist: to_string_alist,
    formats: formats
  };

  var create = function create(index, indexed, data) {
    return {
      indexed: indexed,
      index: index,
      data: data
    };
  };

  var num_index = function num_index(t) {
    return List.length(t.index);
  };

  var num_indexed = function num_indexed(t) {
    return List.length(t.indexed);
  };

  var num_data = function num_data(t) {
    return List.length(t.data);
  };

  var to_term$1 = function to_term$1(t) {
    return (
      /* `Indexed_dataframe */
      [-43001707, t]
    );
  };

  var of_term$1 = function of_term$1(param) {
    return param[1];
  };

  var index = function index(t) {
    return Bolt0_list$Bolt0.map(function (param) {
      var bigdata = param[1];
      var variant = bigdata[0];
      var tmp;

      if (variant >= -714735238) {
        if (variant >= 28091885) {
          throw [Caml_builtin_exceptions.assert_failure,
          /* tuple */
          ["dataframe.ml", 110, 68]];
        }

        tmp = bigdata;
      } else {
        throw [Caml_builtin_exceptions.assert_failure,
        /* tuple */
        ["dataframe.ml", 110, 68]];
      }

      return (
        /* tuple */
        [param[0], tmp]
      );
    }, t.index);
  };

  var group_by_frame_name = function group_by_frame_name(t) {
    var indexed = t.indexed;
    var index$1 = index(t);
    return List.concat(Bolt0_list$Bolt0.map(function (param) {
      var indexed_bigdata = param[1];
      return Bolt0_list$Bolt0.map(function (indexed_frame_name) {
        return Curry._2(List_ext.find_map_exn, index$1, function (param) {
          var match = Bolt0_list$Bolt0.mem(indexed_frame_name, param[0]);

          if (match) {
            return (
              /* tuple */
              [indexed_frame_name,
              /* `Indexed */
              [772834257, indexed_bigdata],
              /* `Index */
              [-784200974, param[1]]]
            );
          }
        });
      }, param[0]);
    }, indexed));
  };

  var to_frames = function to_frames(labeler, t) {
    var l = group_by_frame_name(t);
    var data = t.data;
    var l$1 = List.concat(Bolt0_list$Bolt0.map(function (param) {
      var match = param[0];

      if (match && !match[1]) {
        return (
          /* :: */
          [
          /* tuple */
          [match[0], param[1]], List.concat(Bolt0_list$Bolt0.map(function (param) {
            var index = param[2][1];
            var indexed = param[1][1];
            var frame_name = param[0];
            var variant = indexed[0];

            if (variant >= -714735238) {
              if (variant >= 28091885) {
                var data$prime = Curry._1(Bigdata.Numeric.create_float64, Curry._1(Bigdata.dims, index));

                Curry._3(Bigdata.Numeric.foldi,
                /* () */
                0, function (indices, _acc, value) {
                  return Curry._3(Bigdata.Numeric.set_float, data$prime, indices, Curry._2(Bigdata.Numeric.get_float, indexed,
                  /* array */
                  [Curry._1(Bigdata.Numeric.int_exn, value)]));
                }, index);

                return (
                  /* :: */
                  [
                  /* tuple */
                  [frame_name, data$prime],
                  /* [] */
                  0]
                );
              } else {
                var data$prime$1 = Curry._1(Bigdata.Numeric.create_int64, Curry._1(Bigdata.dims, index));

                Curry._3(Bigdata.Numeric.foldi,
                /* () */
                0, function (indices, _acc, value) {
                  return Curry._3(Bigdata.Numeric.set_int, data$prime$1, indices, Curry._2(Bigdata.Numeric.get_int, indexed,
                  /* array */
                  [Curry._1(Bigdata.Numeric.int_exn, value)]));
                }, index);

                return (
                  /* :: */
                  [
                  /* tuple */
                  [frame_name, data$prime$1],
                  /* [] */
                  0]
                );
              }
            } else {
              var strings = indexed[1];

              var match = Curry._1(Bigdata.dims, indexed);

              var len = match.length;

              if (len >= 3) {
                return Pervasives.failwith("only 1 or 2 dimensions supported");
              } else {
                switch (len) {
                  case 0:
                    return Pervasives.failwith("only 1 or 2 dimensions supported");

                  case 1:
                    var data$prime$2 = Curry._1(Bigdata.Strings.create, Curry._1(Bigdata.dims, index));

                    Curry._3(Bigdata.Numeric.foldi,
                    /* () */
                    0, function (indices, _acc, value) {
                      return Curry._3(Bigdata.Strings.set, data$prime$2, indices, Curry._2(Bigdata.Strings.get, strings,
                      /* array */
                      [Curry._1(Bigdata.Numeric.int_exn, value)]));
                    }, index);

                    return (
                      /* :: */
                      [
                      /* tuple */
                      [frame_name, Curry._1(Bigdata.Strings.to_term, data$prime$2)],
                      /* [] */
                      0]
                    );

                  case 2:
                    var dimy = match[1];
                    return Curry._2(List_ext.init, dimy, function (y) {
                      var data$prime = Curry._1(Bigdata.Strings.create, Curry._1(Bigdata.dims, index));

                      Curry._3(Bigdata.Numeric.foldi,
                      /* () */
                      0, function (indices, _acc, value) {
                        return Curry._3(Bigdata.Strings.set, data$prime, indices, Curry._2(Bigdata.Strings.get, strings,
                        /* array */
                        [Curry._1(Bigdata.Numeric.int_exn, value), y]));
                      }, index);

                      return (
                        /* tuple */
                        [labeler !== undefined ? Curry._2(labeler, frame_name, y) : Curry._2(Printf.sprintf(
                        /* Format */
                        [
                        /* String */
                        Block.__(2, [
                        /* No_padding */
                        0,
                        /* Char_literal */
                        Block.__(12, [
                        /* "_" */
                        95,
                        /* Int */
                        Block.__(4, [
                        /* Int_d */
                        0,
                        /* No_padding */
                        0,
                        /* No_precision */
                        0,
                        /* End_of_format */
                        0])])]), "%s_%d"]), frame_name, y), Curry._1(Bigdata.Strings.to_term, data$prime)]
                      );
                    });
                }
              }
            }
          }, l))]
        );
      } else {
        return Pervasives.failwith("only one dataframe name expected for \"data\" field");
      }
    }, data));
    return of_alist_exn(Bolt0_list$Bolt0.map(function (param) {
      return (
        /* tuple */
        [
        /* :: */
        [param[0],
        /* [] */
        0], param[1]]
      );
    }, l$1));
  };

  var Indexed = {
    create: create,
    num_index: num_index,
    num_indexed: num_indexed,
    num_data: num_data,
    to_term: to_term$1,
    of_term: of_term$1,
    index: index,
    group_by_frame_name: group_by_frame_name,
    to_frames: to_frames
  };

  var pp_hum = function pp_hum(ppf, t) {
    if (t[0] >= -43001707) {
      return Format.fprintf(ppf,
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["<indexed-dataframe>",
      /* End_of_format */
      0]), "<indexed-dataframe>"]);
    } else {
      return Format.fprintf(ppf,
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["<frames>",
      /* End_of_format */
      0]), "<frames>"]);
    }
  };

  var create_indexed = function create_indexed(index, indexed, data) {
    return (
      /* `Indexed_dataframe */
      [-43001707, {
        indexed: indexed,
        index: index,
        data: data
      }]
    );
  };

  var create_frames = function create_frames(data) {
    var param = of_alist(data);

    if (param[0] >= 17724) {
      return (
        /* `Ok */
        [17724,
        /* `Frames */
        [-518380602, param[1]]]
      );
    } else {
      return (
        /* `Duplicate_key */
        [-1048878709, param[1]]
      );
    }
  };

  return {
    Frames: Frames,
    Indexed: Indexed,
    pp_hum: pp_hum,
    create_indexed: create_indexed,
    create_frames: create_frames
  };
}

export { $$String$1 as $$String, Make };
/* Format Not a pure module */